
import AppNav from './shared/app-nav';
import '../css/App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './home/home-page';
import AppFooter from './shared/app-footer';
import { BrowserRouter as Router, Route} from 'react-router-dom';
import AboutUsPage from './about-us/aboutus-page';
import { InfrastructureService, PlatformService, SoftwareService } from './services/cloud-services';
import { ArtificialIntelligence, BigData, GovernanceRiskCompliance, IntenetOfThings, ProgrammeManagement, Strategy } from './services/it-advisory';
import { Industries } from './industries/industries';
import AppBanner from './shared/app-banner';
import ContactPage from './contact-us/contact-us';
import { EnterpriseArchitecture, CustomerRelationManagement, PerformanceManagement, ProjectManagement, ServiceManagementSystem, DocumentManagementSystem, EnterpriseResourcePlanning, CustomApplicationDevelopment } from './services/digital-solutions';

function App() {
  return (
    <div className="App">
      <Router>
          <AppBanner></AppBanner>
          <AppNav></AppNav>
          <Route exact path="/" component={HomePage}></Route>
          <Route path="/about-us" component={AboutUsPage}></Route>

          {/* DIGITAL SOLUTIONS LINKS */}
          <Route path="/digital-solutions/enterprise-architecture" component={EnterpriseArchitecture}></Route>
          <Route path="/digital-solutions/customer-relation-management" component={CustomerRelationManagement}></Route>
          <Route path="/digital-solutions/governance-risk-compliance" component={GovernanceRiskCompliance}></Route>
          <Route path="/digital-solutions/performance-management" component={PerformanceManagement}></Route>
          <Route path="/digital-solutions/project-management" component={ProjectManagement}></Route>
          <Route path="/digital-solutions/service-management-system" component={ServiceManagementSystem}></Route>
          <Route path="/digital-solutions/document-management-system" component={DocumentManagementSystem}></Route>
          <Route path="/digital-solutions/enterprise-resource-planning" component={EnterpriseResourcePlanning}></Route>
          <Route path="/digital-solutions/custom-application-development" component={CustomApplicationDevelopment}></Route>
          
          
          {/* CLOUD SERVICES LINKS */}
          <Route path="/cloud-services/software-services" component={SoftwareService}></Route>
          <Route path="/cloud-services/platform-services" component={PlatformService}></Route>
          <Route path="/cloud-services/infrastructure-services" component={InfrastructureService}></Route>

          {/* CLOUD SERVICES LINKS */}
          <Route path="/it-advisory/governance-risk-compliance" component={GovernanceRiskCompliance}></Route>
          <Route path="/it-advisory/strategy" component={Strategy}></Route>
          <Route path="/it-advisory/internet-of-things" component={IntenetOfThings}></Route>
          <Route path="/it-advisory/big-data-analytics" component={BigData}></Route>
          <Route path="/it-advisory/program-management" component={ProgrammeManagement}></Route> 
          <Route path="/it-advisory/artificial-intelligence" component={ArtificialIntelligence}></Route>

          {/* INDUSTRIES LINKS */}
          <Route path="/industries" component={Industries}></Route>

          {/* CONTACT US */}
          <Route path="/contact-us" component={ContactPage}></Route>

          <AppFooter></AppFooter>
      </Router>
    </div>
  );
}

export default App;
